/**
 * apps/web/src/pages/PromptsPage.tsx
 * -------------------------------------------------------
 * Purpose:
 *   Placeholder UI for managing prompts.
 *
 * High-level data flow:
 *   - In a future iteration, this page would use loaders/actions to call
 *     prompt management endpoints (admin-only).
 *   - For now, it's a static page to preserve navigation and app structure.
 */

import React from 'react';
import { Card, Stack, Text, Title } from '@mantine/core';

export function PromptsPage(): React.ReactElement {
  return (
    <Card withBorder radius="md">
      <Stack gap="sm">
        <Title order={3}>Prompts</Title>
        <Text c="dimmed">
          Prompt management endpoints are not implemented in this starter monolith yet.
          Add BFF endpoints in <code>apps/api</code> and wire them up with RR loaders/actions here.
        </Text>
      </Stack>
    </Card>
  );
}
